/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ClassificationType } from '../../models/classification-type';
import { DemoAccountDataVersionCto } from '../../models/demo-account-data-version-cto';

export interface GetDemoAccountDataHistoryAsync$Plain$Params {
  demoDataType: ClassificationType;
}

export function getDemoAccountDataHistoryAsync$Plain(http: HttpClient, rootUrl: string, params: GetDemoAccountDataHistoryAsync$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<DemoAccountDataVersionCto>>> {
  const rb = new RequestBuilder(rootUrl, getDemoAccountDataHistoryAsync$Plain.PATH, 'get');
  if (params) {
    rb.path('demoDataType', params.demoDataType, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<DemoAccountDataVersionCto>>;
    })
  );
}

getDemoAccountDataHistoryAsync$Plain.PATH = '/demo-account-data/{demoDataType}/history';
